export default class FeedbackMasterVotesFactory {
  create() {
    const items = []
    for (let i = 0; i < 6; i++) {
      items.push({
        name: i,
        id: i,
      })
    }
    return items
  }
}
